// ABOUTME: Base API fetch wrapper used as the Orval custom mutator.
// ABOUTME: Attaches Content-Type header and handles non-ok responses uniformly.

const BASE = import.meta.env.VITE_API_URL ?? 'http://localhost:3001'

export class ApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
  }
}

export const apiRequest = async <T>(
  url: string,
  options: RequestInit = {},
): Promise<T> => {
  const res = await fetch(`${BASE}${url}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

  if (!res.ok) {
    const body = await res.text().catch(() => '')
    let message = `API error ${res.status} for ${url}`
    try {
      const parsed = JSON.parse(body)
      if (parsed.message) message = Array.isArray(parsed.message) ? parsed.message.join(', ') : parsed.message
    } catch { /* use default message */ }
    throw new ApiError(res.status, message)
  }

  const text = await res.text()
  const data = text ? JSON.parse(text) : undefined
  return { data, status: res.status, headers: res.headers } as unknown as T
}
